











































































import {Component, Prop, Vue} from "vue-property-decorator";
import Customer from "@/api/Customer";
import CustomerService from "@/service/CustomerService";
import RenderModal from "@/components/Shared/RenderModal.vue";
import CustomerMobile from "@/api/Customer/CustomerMobile";

@Component({
  components: {RenderModal}
})
export default class CustomerMobileEditFormView extends Vue {
  @Prop() private customer!: Customer;
  private customerMobile = new CustomerMobile();
  private showWaiting = false;
  private showVerificationField = false;
  private remainingTime = 60;
  private remainingTimeCounter = 60;
  private timeToResend = 5;

  mounted() {
    if (this.customer) {
      this.customerMobile.mobile = this.customer.mobile;
    }
    setInterval(() => {
      this.countdown();
    }, 1000)
  }

  closeForm(saved = false) {
    this.$emit('close-customer-info-form', {saved: saved});
  }

  async changeCustomerMobile() {
    this.showWaiting = true;
    const response = await CustomerService.changeCustomerMobile(this.customerMobile);
    if (response.success) {
      this.showVerificationField = true;
      const remainingObject = await CustomerService.getActivationRemainingTime();
      this.remainingTime = remainingObject.remainingTime;
      this.remainingTimeCounter = remainingObject.remainingTime;
      this.timeToResend = remainingObject.timeToResend;
      this.showWaiting = false;
    } else {
      alert(response.message);
      this.showWaiting = false;
    }
  }

  async saveCustomerMobile() {
    const response = await CustomerService.saveCustomerMobile(this.customerMobile);
    if (response.success) {
      this.closeForm(true);
    } else {
      alert(response.message);
    }
  }

  async resendActivationCode() {
    this.showWaiting = true;
    const response = await CustomerService.resendActivationCode();
    if (response.success) {
      const remainingObject = await CustomerService.getActivationRemainingTime();
      this.remainingTime = remainingObject.remainingTime;
      this.remainingTimeCounter = remainingObject.remainingTime;
      this.timeToResend = remainingObject.timeToResend;
      this.showWaiting = false;
    } else {
      alert(response.message);
      this.showWaiting = false;
    }
  }

  countdown() {
    if (this.showVerificationField) {
      this.remainingTimeCounter--;
    }
  }

  get showResend() {
    return (this.remainingTime - this.remainingTimeCounter) > this.timeToResend;
  }
}
